import React from 'react';
import { Modal, Form, Select } from 'antd';

const statusOptions = [
  { value: "Under Review", label: "Under Review" },
  { value: "Disruption In Progress", label: "Disruption In Progress" },
  { value: "Verified Genuine", label: "Verified Genuine" },
  { value: "Verified Scam", label: "Verified Scam" },
  { value: "Notify Brand", label: "Notify Brand" },
  { value: "Scam Disrupted", label: "Scam Disrupted" },
];

const StatusModal = ({
  visible,
  onOk,
  onCancel,
  form,
  statusModal,
  title = "Batch Change Status"
}) => {
  return (
    <Modal
      title={title}
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
    >
      <Form form={form} labelCol={{ span: 4 }}>
        <Form.Item
          name="status"
          label="NewStatus"
        >
          <Select options={statusOptions} />
        </Form.Item>

        {statusModal === 1 &&
          <>
            <Form.Item name="isWhitelist" label="Whitelist">
              <Select
                options={[
                  { value: '1', label: "Yes" },
                  { value: '0', label: "No" },
                ]}
              />
            </Form.Item>

            {/* 根据 isWhitelist 值动态渲染 brand 表单项 */}
            {/* <Form.Item shouldUpdate={(prev, current) => prev.isWhitelist !== current.isWhitelist}>
              {({ getFieldValue }) =>
                getFieldValue('isWhitelist') === '1' && (
                  <Form.Item
                    name="brand"
                    label="Brand"
                    rules={[{ required: true, message: 'Please select a brand' }]}
                  >
                    <Input placeholder="Enter brand" />
                  </Form.Item>
                )
              }
            </Form.Item> */}
          </>
        }
      </Form>
    </Modal>
  );
};

export default StatusModal;
